import { render, staticRenderFns } from "./loggedin.vue?vue&type=template&id=4d8a0a2b&"
import script from "./loggedin.vue?vue&type=script&lang=js&"
export * from "./loggedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports